import React, {Component} from "react";
import PropTypes from 'prop-types';

class ClearD3PlusContext extends Component {

  getChildContext() {
    return {d3plus:{}};
  }

  render() {
    return (<>{this.props.children}</>);
  }
}

ClearD3PlusContext.childContextTypes = {
  d3plus: PropTypes.object
};

export default ClearD3PlusContext;
